import { orderStatusFormStyles as styles } from "@insite/content-library/Widgets/OrderStatus/OrderStatusForm";
import { mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.form = {
    ...styles.form,
    css: css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        gap: 15px;

        ${mediaQueriesBP.minMD} {
            flex-direction: row;
            justify-content: flex-start;
            align-items: flex-end;
        }
    `,
};

styles.submitButton = {
    ...styles.submitButton,
    css: css`
        height: 40px;
        width: 100%;
        ${mediaQueriesBP.minMD} {
            width: auto;
            height: 50px;
        }
    `,
};

styles.orderNumberTextField = {
    cssOverrides: {
        formField: css`
            width: 100%;
            ${mediaQueriesBP.minMD} {
                width: auto;
            }
        `,
    },
};

styles.emailOrPostalCodeTextField = {
    cssOverrides: {
        formField: css`
            width: 100%;
            ${mediaQueriesBP.minMD} {
                width: auto;
            }
        `,
    },
};
